(() => {
  const normalizeText = (value) => String(value ?? '').replace(/\s+/g, ' ').trim();

  const formatPriceFromCents = (priceInCents) => {
    if (priceInCents === undefined || priceInCents === null || priceInCents === '') return '';

    const cents = Number(priceInCents);
    return Number.isFinite(cents) ? (cents / 100).toFixed(2) : '';
  };

  const formatPriceFromText = (value) => {
    const price = normalizeText(value)
      .replace(/\s/g, '')
      .replace(/[^\d,.-]/g, '');
    if (!/\d/.test(price)) return '';

    const isNegative = price.includes('-');
    const unsignedPrice = price.replace(/-/g, '');
    const commaIndex = unsignedPrice.lastIndexOf(',');
    const dotIndex = unsignedPrice.lastIndexOf('.');
    const separatorIndex = Math.max(commaIndex, dotIndex);
    const decimalLength = separatorIndex === -1 ? 0 : unsignedPrice.length - separatorIndex - 1;
    const hasDecimalSeparator = separatorIndex !== -1 && decimalLength > 0 && decimalLength <= 2;
    const integerPart = (hasDecimalSeparator
      ? unsignedPrice.slice(0, separatorIndex)
      : unsignedPrice
    ).replace(/\D/g, '');
    const decimalPart = hasDecimalSeparator
      ? unsignedPrice.slice(separatorIndex + 1).replace(/\D/g, '')
      : '';
    const numericPrice = Number(
      `${isNegative ? '-' : ''}${integerPart || '0'}.${decimalPart || '0'}`,
    );

    return Number.isFinite(numericPrice) ? numericPrice.toFixed(2) : '';
  };

  const getElementLabel = (
    element,
    {
      selectors = ['.btn-text'],
      fallback = '',
      preferTextContent = false,
      deriveFromTagName = true,
    } = {},
  ) => {
    if (!element) return normalizeText(fallback);

    const selectorList = Array.isArray(selectors) ? selectors : [selectors];
    const selectedText = selectorList
      .filter(Boolean)
      .map((selector) => normalizeText(element.querySelector?.(selector)?.textContent))
      .find(Boolean);
    if (selectedText) return selectedText;

    const textContent = normalizeText(element.textContent);
    if (preferTextContent && textContent) return textContent;

    const accessibleLabel = normalizeText(
      element.getAttribute?.('aria-label') || element.getAttribute?.('title'),
    );
    if (accessibleLabel) return accessibleLabel;
    if (textContent) return textContent;
    if (!deriveFromTagName) return normalizeText(fallback);

    const elementName = normalizeText(element.localName)
      .replace(/^shopify-/, '')
      .replace(/-wallet-button$|-button$/, '')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (character) => character.toUpperCase());

    return elementName && elementName !== 'Div' ? elementName : normalizeText(fallback);
  };

  window.ga4TrackingUtils = Object.freeze({
    ...(window.ga4TrackingUtils || {}),
    normalizeText,
    formatPriceFromCents,
    formatPriceFromText,
    getElementLabel,
  });

  if (window.trackGA4Event) return;

  /**
   * Push a standard GA4 event to the GTM dataLayer.
   *
   * @param {{
   *   event_name: string,
   *   event_parameters?: Record<string, unknown>
   * }} trackingData
   * @returns {Record<string, unknown> | null}
   */
  const trackGA4Event = ({ event_name: eventName, event_parameters: eventParameters = {} } = {}) => {
    if (typeof eventName !== 'string' || !eventName.trim()) {
      console.warn('[trackGA4Event] event_name is required.');
      return null;
    }

    const parameters =
      eventParameters && typeof eventParameters === 'object'
        ? { ...eventParameters }
        : {};

    const eventPayload = {
      event: 'ga4Event',
      event_name: eventName.trim(),
      event_parameters: parameters,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push(eventPayload);

    return eventPayload;
  };

  window.trackGA4Event = trackGA4Event;
})();
